// List faq urls
import faqUrls from '@/lib/urls/faqUrls';

const faqUrl = (key: keyof typeof faqUrls) => {
    const url =
        key in faqUrls
            ? `${process.env.NEXT_PUBLIC_BASE_FAQ_URL}${faqUrls[key]}`
            : process.env.NEXT_PUBLIC_BASE_FAQ_URL;

    return url;
};

export default faqUrl;
